import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/global.css';
import './styles/components.css';
import './styles/loader.css';
import './styles/mobile.css';

import { ToastProvider } from './context/ToastContext';
import { Web3Provider } from './context/Web3Context';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <Web3Provider>
        <App />
      </Web3Provider>
    </ToastProvider>
  </React.StrictMode>
);
